import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import DesktopTaskbar from "./DesktopTaskbar";
import MobileTaskbar from "./MobileTaskbar";

/* Swipe hook */
const useSwipeDrawer = ({ onOpen, onClose }) => {
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);
  const minDistance = 70;

  const onTouchStart = (e) => {
    touchStartX.current = e.targetTouches[0].clientX;
  };
  const onTouchMove = (e) => {
    touchEndX.current = e.targetTouches[0].clientX;
  };
  const onTouchEnd = () => {
    const distance = touchEndX.current - touchStartX.current;
    if (distance > minDistance) onOpen();
    if (distance < -minDistance) onClose();
  };

  return { onTouchStart, onTouchMove, onTouchEnd };
};

const Taskbar = () => {
  const location = useLocation();

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isThemeDropdownOpen, setIsThemeDropdownOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 943);
  const [showLogoText, setShowLogoText] = useState(window.innerWidth >= 435);
  const [hideBottomBar, setHideBottomBar] = useState(false);
  const [hideTopBar, setHideTopBar] = useState(false);

  const menuRef = useRef(null);
  const themeBtnRef = useRef(null);
  const themeDropdownRef = useRef(null);
  const moreBtnRef = useRef(null);
  const moreDropdownRef = useRef(null);

  /* RESIZE */
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 943);
      setShowLogoText(window.innerWidth >= 435);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /* SCROLL HIDE */
  useEffect(() => {
    let lastScrollY = window.scrollY;
    const handleScroll = () => {
      if (window.scrollY > lastScrollY) {
        setHideBottomBar(true);
        setHideTopBar(true);
      } else {
        setHideBottomBar(false);
        setHideTopBar(false);
      }
      lastScrollY = window.scrollY;
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  /* OUTSIDE CLICK */
  useEffect(() => {
    const handleClick = (e) => {
      if (
        themeDropdownRef.current &&
        !themeDropdownRef.current.contains(e.target) &&
        themeBtnRef.current &&
        !themeBtnRef.current.contains(e.target)
      ) {
        setIsThemeDropdownOpen(false);
      }

      if (
        moreDropdownRef.current &&
        !moreDropdownRef.current.contains(e.target) &&
        moreBtnRef.current &&
        !moreBtnRef.current.contains(e.target)
      ) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  /* SWIPE HANDLERS */
  const swipeHandlers = useSwipeDrawer({
    onOpen: () => isMobile && setIsDrawerOpen(true),
    onClose: () => setIsDrawerOpen(false),
  });

  return (
    <div
      {...swipeHandlers} // attach swipe to the outer div
      className="relative"
    >
      {!isMobile && (
        <DesktopTaskbar
          location={location}
          showLogoText={showLogoText}
          isThemeDropdownOpen={isThemeDropdownOpen}
          setIsThemeDropdownOpen={setIsThemeDropdownOpen}
          menuOpen={menuOpen}
          setMenuOpen={setMenuOpen}
          themeBtnRef={themeBtnRef}
          themeDropdownRef={themeDropdownRef}
          moreBtnRef={moreBtnRef}
          moreDropdownRef={moreDropdownRef}
        />
      )}

      {isMobile && (
        <MobileTaskbar
          isMobile={isMobile}
          location={location}
          isDrawerOpen={isDrawerOpen}
          setIsDrawerOpen={setIsDrawerOpen}
          isThemeDropdownOpen={isThemeDropdownOpen}
          setIsThemeDropdownOpen={setIsThemeDropdownOpen}
          menuOpen={menuOpen}
          setMenuOpen={setMenuOpen}
          hideTopBar={hideTopBar}
          hideBottomBar={hideBottomBar}
          themeBtnRef={themeBtnRef}
          themeDropdownRef={themeDropdownRef}
          menuRef={menuRef}
        />
      )}
    </div>
  );
};

export default Taskbar;
